var React = require('react');
var ReactIntl = require('react-intl');
var injectIntl = ReactIntl.injectIntl;
var createReactClass = require('create-react-class');
var { Security, ArrowRight, WarningFilled } = require('@metro-ui/icons');
var { Grid, Cell, NavigationList, NavigationListItem } = require('@metro-ui/core');
var UserCredentials = require('./UserCredentials');
var TwoFaTotpCard = require('./TwoFaTotpCard');
var TwoFaTotpSmsCard = require('./TwoFaTotpSmsCard');
var TwoFactorFingerprint = require('./TwoFactorFingerprint');
var AuthenticationContainer = require('./AuthenticationContainer');
var defaultMessages = require('../../i18n/messages/default');
var LoginStore = require('../../stores/LoginStore');
var UrlUtils = require('../../utils/urlUtils');
var AppConstants = require('../../constants/AppConstants');
const LoginActions = require('../../actions/LoginActions');
var { isEmpty } = require('lodash');
var LoginPreferencesNavigationBar = require('./LoginPreferencesNavigationBar.js');

var LoginPreferencesMobileView = createReactClass({
    displayName: 'LoginPreferencesMobileView',
    getInitialState: function () {
        return {
            key: 6,
            twoFactorAuthInfo: {}
        }
    },

    onNavItemClick: function (key) {
        this.setState({ key: key });
    },


    componentDidMount: function () {
        //To handle the backbutton event
        window.onpopstate = this.onBackButtonEvent;
        history.pushState({}, '');


        const appState = LoginStore.getState();
        LoginStore.addTwoFATempSecretReceived(() => {
            this.setState({ twoFactorAuthInfo: appState.twoFATempSecretData });
        });
        if(!isEmpty(this.state.twoFactorAuthInfo)){
            LoginActions.triggerToast(this.props.intl.formatMessage(defaultMessages['loginpreferences.unknown_auth_token']), "error")
        }
    },

    onBackButtonEvent: function (e) {
        UrlUtils.delete_cookie(AppConstants.cookie.METRO_IDENTITY);
        history.back();
    },

    onDoneClick: function () {
        const appState = LoginStore.getState();
        if(appState.originalAuthenticationMethod == AppConstants.LoginPreferences.AUTH_METHOD_USER_CREDENTIAL && this.props.userAuthenticationMethod != AppConstants.LoginPreferences.AUTH_METHOD_USER_CREDENTIAL)
        {
            UrlUtils.delete_cookie(AppConstants.cookie.METRO_IDENTITY);
            window.location= this.props.redirectUri;
        }
        else if(this.props.userAuthenticationMethod != AppConstants.LoginPreferences.AUTH_METHOD_USER_CREDENTIAL)
        {
            window.location= this.props.redirectUri;
        }
        else
            return false;
    },

    setNavgationState: function (value) {
        this.setState(value)
    },

    renderNavigationMenu: function () {
        return (
            <NavigationList
                className="navigation-sidebar-mobile"
                isMobile
                title={<strong>{this.props.name}</strong>}
                titleId="navigation-title">
                <NavigationListItem
                    className="navbar-submenu-mobile"
                    Icon={Security}>
                    <strong>
                        {this.props.intl.formatMessage(defaultMessages['loginpreferences'])}
                    </strong>
                </NavigationListItem>
                <NavigationListItem
                    className="navbar-submenu-mobile"
                    onClick={this.onNavItemClick.bind(this, 1)}>
                    {this.props.intl.formatMessage(defaultMessages['loginpreferences.usercredentials'])}
                </NavigationListItem>
                <NavigationListItem
                    className="navbar-submenu-mobile preferences-nav-item"
                    onClick={this.onNavItemClick.bind(this, 2)}>
                    {this.props.intl.formatMessage(defaultMessages['loginpreferences.2fa'])} {this.props.userAuthenticationMethod == AppConstants.LoginPreferences.AUTH_METHOD_USER_CREDENTIAL && <WarningFilled />}
                </NavigationListItem>
                {this.props.userAuthenticationMethod != AppConstants.LoginPreferences.AUTH_METHOD_USER_CREDENTIAL &&
                    <NavigationListItem
                        className="navbar-submenu-mobile"
                        Icon={ArrowRight}
                        onClick={this.onDoneClick.bind(this)}>
                        <strong>
                            {this.props.intl.formatMessage(defaultMessages['loginpreferences.done'])}
                        </strong>
                    </NavigationListItem>}
            </NavigationList>
        );
    },

    renderLoginPreferencesCard: function () {
        const key = this.state.key;
        switch (key) {
            case 1:
                return (
                    <React.Fragment>
                        <LoginPreferencesNavigationBar
                            headingText={this.props.intl.formatMessage(defaultMessages['loginpreferences'])}
                            onNavItemClick={this.onNavItemClick.bind(this, 6)} />
                        <UserCredentials {...this.props} />
                    </React.Fragment>);
            case 2:
                return (
                    <React.Fragment>
                        <LoginPreferencesNavigationBar
                            headingText={this.props.intl.formatMessage(defaultMessages['loginpreferences'])}
                            onNavItemClick={this.onNavItemClick.bind(this, 6)} />
                        <AuthenticationContainer
                            {...this.props}
                            onNavItemClick={this.onNavItemClick.bind(this)} />
                    </React.Fragment>);
            case 3:
                return !isEmpty(this.state.twoFactorAuthInfo) ?
                    <React.Fragment>
                        <LoginPreferencesNavigationBar />
                        <TwoFaTotpCard
                            {...this.props}
                            onNavItemClick={this.onNavItemClick.bind(this)}
                            setState={this.setNavgationState.bind(this)}
                            twoFactorAuthInfo={this.state.twoFactorAuthInfo}
                            realmId={this.props.realmId}
                            traceId={this.props.traceId}
                            countrycode={this.props.countrycode} /></React.Fragment> :
                    <React.Fragment>
                        <LoginPreferencesNavigationBar />
                    </React.Fragment>;
            case 4:
                return <React.Fragment>
                    <LoginPreferencesNavigationBar />
                    <TwoFaTotpSmsCard
                        onNavItemClick={this.onNavItemClick.bind(this)}
                        {...this.props}
                        setState={this.setNavgationState.bind(this)} />
                </React.Fragment>;
            case 5:
                return <React.Fragment>
                    <LoginPreferencesNavigationBar />
                    <TwoFactorFingerprint
                        onNavItemClick={this.onNavItemClick.bind(this)}
                        {... this.props}
                        setState={this.setNavgationState.bind(this)} />
                </React.Fragment>;
            case 6:
            default:
                return this.renderNavigationMenu();
        }
    },

    render: function () {
        const props = {
            name: this.props.name,
            idToken: this.props.idToken,
            userType: this.props.userType,
            email: this.props.email,
            decodedIdToken: this.props.decodedIdToken
        };
        return (
            <Grid >
                <Cell span={8} start={1} row={1}>
                    {this.renderLoginPreferencesCard()}
                </Cell>
            </Grid>
        );
    }
});

module.exports = injectIntl(LoginPreferencesMobileView);
